<template>
  <div class="info">
    <header class="am-header">
      <h1>
        <span class="title-main" data-title="支付宝口令红包">支付宝【天猫券】</span>
      </h1>
    </header>
    <div class="am-content">
      <div style="text-align: center;">
         <div id="qrCode" ref="qrCodeDiv" style="width:210px;height:210px;margin:auto;"></div>
      </div>
      <div class="am-list">
        <div class="J-inputClear am-list-item am-list-item-form am-flexbox">
          <label for="logon_id">支付单号:</label>
          <div class="am-flexbox-item">
            <input 
            v-model="orderInfo.orderId"
              name="txtod"
              type="text"
              id="txtod"
              readonly
              maxlength="100"
            />
          </div>
        </div>
        <div class="J-inputClear am-list-item am-list-item-form am-flexbox">
          <label for="logon_id">订单金额:</label>
          <div class="am-flexbox-item">
            <input
             v-model="orderInfo.realMoney"
              name="txtmoney"
              type="text"
              id="txtmoney"
              readonly
              maxlength="100"
            />
          </div>
        </div>
      </div>
      <div class="am-section">
        <div class="am-ft-pb-10">
          <div style="color: red; font-weight: bold; text-align: center;">如果显示已经停止访问该网页，请截图扫码支付！</div>
           <a class="am-button am-button-blue" id="dopay" :href="orderInfo.jumpUrl">跳转到支付宝支付</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
let axios = require("axios");
import QRCode from "qrcodejs2";
export default {
   name: "otherDjInfo",
   data() {
    return {
      orderInfo: {},
      param: {},
      ordernum:'',
    };
  },
  created() {
    var self = this;
    try {
      var param = this.$route.query;
      var data = [];
      for (const i in param) {
        var item = param[i];
        item = Base64.decode(decodeURI(item));
        if (item && item.indexOf("|") >= 0) {
          item = item.split("|")[0];
        }
        data.push(item);
      }
      console.log("Url:"+data[0]);
      console.log("Key:"+data[1]);
      var url = `${data[0]}/Facade/GetMecOrderInfo?orderid=${data[1]}&type=3`;
      axios
        .get(url)
        .then(function(response) { 
          if(response.data.code == 1){
          self.orderInfo = response.data.result;
          self.$nextTick(function() {
              self.bindQRCode(self.orderInfo.qrCode);
            });
          }
        })
        .catch(() => {
          alert("请求失败");
        });
    } catch (error) {
      alert("数据异常，请重新尝试");
    }
  },
  methods: {
    bindQRCode: function(url) {
      new QRCode(this.$refs.qrCodeDiv, {
        text: url,
        width: 220,
        height: 220,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
   }
}
</script>

<style lang="less" scoped>
.info {
  background: #f5f5f9;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  font-family: Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
  font-weight: 300;

  input,label {
    font-size: 16px;
    line-height: 1.5;
    color: #333;
    font-family: Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
    font-weight: 300;
  }

  .am-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: box;
    width: 100%;
    position: relative;
    padding: 7px 0;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
    background: #1d222d;
    height: 50px;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    box-pack: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    box-align: center;

    h1 {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      box-flex: 1;
      line-height: 18px;
      text-align: center;
      font-size: 18px;
      font-weight: 300;
      color: #fff;
    }
  }
  .am-content {
    padding-top: 15px;

    .am-flexbox {
      display: flex;
      align-items: center;
      background: #fff;
      border-top: 1px solid #e5e5e5;
      box-sizing: border-box;
      padding: 0 15px;
      font-size: 16px;
      color: #000;
      font-weight: 300;
      font-size: 16px;
      line-height: 1.5;
      font-family: Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
      font-weight: 300;

      &:last-child {
        border-bottom: 1px solid #e5e5e5;
      }

      .am-flexbox-item {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        box-flex: 1;
        margin-left: 15px;
        min-width: 20px;
      }

      input {
        padding: 8px 0;
        width: 100%;
        height: 45px;
        font-size: 16px;
        color: #000;
      }
    }
    .am-list {
      padding: 20px 10px 20px
    }
  }
  .am-section {
    padding: 0 15px 10px;
    overflow: auto;
    .am-ft-pb-10 {
      padding-bottom: 10px !important;
    }
    .am-button {
      -ms-box-sizing: border-box;
      box-sizing: border-box;
      display: inline-block;
      margin: 0;
      padding: 4px 8px;
      width: 100%;
      text-align: center;
      font-size: 18px;
      line-height: 2;
      border-radius: 4px;
      background-clip: padding-box;
    }
    .am-button-blue {
      border: 1px solid #0ae;
      color: #fff;
      background: #0ae;
    }
  }
}
</style>